@if (loading) {
  <mat-spinner
    class="mobile-data-table__spinner"
    >
  </mat-spinner>
}
@if (!isDataAvailable() && !loading) {
  <div class="flex-container mobile-data-table__error"
    fxLayout="row"
    fxLayoutAlign="start center"
    >
    <data-table-error [errorText]="noResultsMessage"
      [actionableText] = "actionableErrorText"
      [isVisibleDeepLinkMsg]="isVisibleDeepLinkMsg"
      [deepLinkMessage]="deepLinkMessage"
      (deepLinkMessageClick)="onClickDeepLinkMsg()"
      (textClick)="onErrorTextClick.emit()">
    </data-table-error>
  </div>
}
@if (enableMobileCheckbox && !loading && isDataAvailable()) {
  <div
    class="mobile-data-table__select-all-container"
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div fxLayoutAlign="start center">
      @if (enableMobileCheckbox) {
        <mat-checkbox
          class="mobile-data-table__select-all-checkbox"
          [checked]="isCustomersSelectedOnPage()"
          [disabled]="disableCheckboxes"
          (change)="isAllMobileCustomersSelected($event)">
        </mat-checkbox>
      }
      @if (enableMobileCheckbox) {
        <div>Select All</div>
      }
    </div>
    @if (mobileActionMenuMetaData) {
      <actions-menu
        [hidden]="mobileActionMenuMetaData.hidden"
        [canMakeInactive]="mobileActionMenuMetaData.isInactiveView"
        [selectedCustomerIds]="mobileActionMenuMetaData.customerSelections"
        [showCreateSavedGroupOption]="mobileActionMenuMetaData.showCreateSavedGroupOption"
        [disableActionMenu]="mobileActionMenuMetaData.disableActionMenu">
      </actions-menu>
    }
  </div>
}
@if (isDataAvailable()) {
  <mat-nav-list>
    @for (row of rows; track trackRow($index, row); let i = $index) {
      <mat-list-item
                 [ngClass]="{'mobile-data-table__blue-row-background' : (i % 2  !== 0),
                             'mobile-data-table__white-row-background' : (i % 2  === 0),
                             'mobile-data-table__blue-row-non-interactive-background' : (i % 2  !== 0) && isRowNonInteractive(row)}"
        [disableRipple]="enableMobileCheckbox || shouldDisableRow(row) || disableRipple"
        (click)="rowClicked(row)"
        fxLayout="row"
        fxLayoutAlign="center center"
        class="mobile-data-table__list-item"
        (keydown.enter)="$event.target === $event.currentTarget && (rowClicked(row))">
        @if (enableMobileCheckbox) {
          <mat-checkbox class="mobile-data-table__checkbox"
            [(ngModel)]="row.state"
            [disabled]="disableCheckboxes"
            (click)="$event.stopPropagation(); checkboxClick(row)"
            (keydown.enter)="onCheckboxEnter($event, row)">
          </mat-checkbox>
        }
        @if (mobileDeleteEnabled) {
          <div fxFlex="15">
            <button
              type="button"
              class="mobile-data-table__icon-button"
              aria-label="Delete"
              (click)="$event.stopPropagation(); deleteClicked(row)">
              <img alt="" class="mobile-data-table__delete-icon" src="{{deleteIconUrl}}">
            </button>
          </div>
        }
        @if (useMembershipAsIcon) {
          <div fxFlex="12">
            <member-status [membership]="getMembership(row)"
              [displayCfaOne]="getDisplayCfaOne()"
              [isEnableSignatureMembership]="isEnableSignatureMembership"
              [shouldDisplayIcon]="true"
              [shouldDisplayLabel]="false"
              [isMobile]="true">
            </member-status>
          </div>
        }
        <div fxFlex>
          @for (col of mobileColumns; track trackColumn($index, col)) {
            <div
              class="mobile-data-table"
              [ngClass]="{'mobile-data-table__row-disabled' : shouldDisableRow(row)}">
              <data-table-cell [row]="row"
                [col]="col"
                [isMobile]="true"
                [mobileTitle]="col.mobileTitle"
                [mobileTitleBold]="col.mobileTitleBold"
                [isEnableSignatureMembership]="isEnableSignatureMembership"
                [shouldDisplayIcon]="shouldDisplayIcon"
                [shouldDisplayLabel]="shouldDisplayLabel"
                [shouldDisplayMemberText]="shouldDisplayMemberText"
                (onExternalLinkClick)="viewSyncReport(row)">
              </data-table-cell>
            </div>
          }
        </div>
        @if (!shouldHideChevron(row) && !shouldDisplayInfo(row)) {
          <mat-icon class="mobile-data-table__chevron" fxFlex>keyboard_arrow_right</mat-icon>
        }
        @if (shouldDisplayInfo(row)) {
          <help-text class="mobile-data-table__chevron" fxFlex
            [helpText]="displayInfo(row)"
            [displayOnLeft]= "true"
            [blockDisplay]="true">
          </help-text>
        }
        @if (row[noteProp] && row[noteProp].length > 0) {
          <div class="mobile-data-table__note-section">
            <button
              type="button"
              class="mobile-data-table__note-section-label"
              [attr.aria-expanded]="row.isNoteOpen ? 'true' : 'false'"
              (click)="$event.stopPropagation(); noteClicked(row)">
              {{ row.isNoteOpen ? 'Hide Notes' : 'View Notes' }}
            </button>
          </div>
        }
        @if (row[noteProp] && row[noteProp].length > 0 && row.isNoteOpen) {
          <div fxLayout="row wrap" fxFlex="100">
            @for (note of row[noteProp]; track trackNote($index, note)) {
              <div fxLayout="row" fxFlex="100">
                <div class="mobile-data-table__note">
                  <div>
                    <span class="mobile-data-table__note-name">{{note.updatedBy}}</span>
                    <span class="mobile-data-table__note-date"> - {{note.updatedAt | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}</span>
                  </div>
                  <div class="mobile-data-table__note-text">{{note.note}}</div>
                </div>
              </div>
            }
          </div>
        }
      </mat-list-item>
    }
    <div infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollUpDistance]="2"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onscroll()">
    </div>
  </mat-nav-list>
}
